import type { PropertyFilters } from '~/core/entities/property/filters';
import type { PageName } from '~/presenters/PropertyFiltersPresenter';

import { cva } from 'class-variance-authority';

export { default as FiltersBar } from './Bar.vue';

export interface FiltersBarProps {
	isFetchingProperties: boolean;
	countProperties: number;
	page: PageName;
	fixed?: boolean;
	filters: PropertyFilters;
	numberOfAppliedClosedFilters?: number;
	appliedFilterKeys?: (keyof PropertyFilters)[];
}

export type SearchSuggestSelect = {
	code: string | null;
	regions: Required<PropertyFilters['regions']>;
	cities: Required<PropertyFilters['cities']>;
	macroregions: Required<PropertyFilters['macroregions']>;
	searchTerm: string;
	poiLocationLat?: number;
	poiLocationLng?: number;
};

export type ChangedKeysToFilterSearch = {
	regions: boolean;
	cities: boolean;
	macroregions: boolean;
};

export const navVariants = cva(
	'fixed z-30 transition-[transform,color,background-color] duration-300 ease-in-out',
	{
		variants: {
			transform: {
				none: '',
				down: 'translate-y-0',
				up: '-translate-y-20'
			}
		},
		defaultVariants: {
			transform: 'none'
		}
	}
);
